<template>
  <div fluid pt-0 pl-0 pr-0 class="headcontainer pb-xs-10">
    <h1
      class="hidden-sm-and-down header text-center text-uppercase"
      v-prlx="{
        speed: -1,
        limit: { min: getHeight, max: 30 },
      }"
    >
      {{ header }}
    </h1>

    <h1 class="hidden-md-and-up header text-center text-uppercase">
      {{ header }}
    </h1>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["header"],
  computed: {
    getHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 0;
        case "sm":
          return 0;
        case "md":
          return -70;
        case "lg":
          return -90;
        case "xl":
          return -100;
        default:
          return -100;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Fauna+One&display=swap");
@import "~vuetify/src/styles/settings/_variables.scss";
@import url("https://fonts.googleapis.com/css2?family=Khula:wght@800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap");

.headcontainer {
  overflow: hidden;
  position: relative;
  z-index: 10;
}

.narrow {
  .header {
    font-size: 2.8rem;
    letter-spacing: 0.1rem;
  }

  @media #{map-get($display-breakpoints, 'xl-only')} {
    .header {
      font-size: 10rem;
      font-weight: normal;
      letter-spacing: 3.5rem;
      margin-top: 0;
    }
  }

  @media #{map-get($display-breakpoints, 'lg-only')} {
    .header {
      font-size: 8.4rem;
      letter-spacing: 1.2rem;
      margin-top: 0;
      // margin-top: -4.7rem;
    }
  }
  @media #{map-get($display-breakpoints, 'md-only')} {
    .header {
      font-size: 6.8rem;
      letter-spacing: 0.7rem;
      margin-top: 0;
      // margin-top: -4rem;
    }
  }

  @media #{map-get($display-breakpoints, 'sm-only')} {
    .header {
      font-size: 4.5rem;
      letter-spacing: 0.2rem;
      margin-top: 0;
      // margin-top: -2.5rem;
    }
  }
}

.header {
  color: #707070;
  // font-family: 'Fauna One', serif;
  // font-family: 'Khula', sans-serif;
  font-family: "Montserrat", sans-serif;
  font-weight: normal;
  margin-top: 0.5rem;
  font-size: 3.2rem;
  letter-spacing: 0.5rem;
}
@media #{map-get($display-breakpoints, 'xl-only')} {
  .header {
    font-size: 10rem;
    font-weight: normal;
    letter-spacing: 3.5rem;
    margin-top: 0;
  }
}

@media #{map-get($display-breakpoints, 'lg-only')} {
  .header {
    font-size: 8.4rem;
    letter-spacing: 2.4rem;
    margin-top: 0;
    // margin-top: -4.7rem;
  }
}
@media #{map-get($display-breakpoints, 'md-only')} {
  .header {
    font-size: 6.8rem;
    letter-spacing: 1.8rem;
    margin-top: 0;
    // margin-top: -4rem;
  }
}

@media #{map-get($display-breakpoints, 'sm-only')} {
  .header {
    font-size: 4.5rem;
    letter-spacing: 1.2rem;
    margin-top: 0;
    // margin-top: -2.5rem;
  }
}
</style>